<template>
    <div class="member-item">
        <!--<div v-on:click="toggleEmail($el)" class="image-overflow-container">-->
            <!--<img :src="image">-->
        <!--</div>-->
        <div class="image-overflow-container">
            <v-img :src="image">
                <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-layout>
                </template>
            </v-img>
        </div>
        <div class="member-text">
            <p class="member-text__name">{{ name }}</p>
            <div class="member-text__detail-holder">
                <p class="member-text__description">{{ description }}</p>
                <p class="member-text__email hidden">{{ email }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Members",
        props: {
            name: String,
            image: String,
            description: String,
            email: String,
        },
        methods: {
            toggleEmail: function(elm){
                let description = elm.querySelector('.member-text__description');
                let email = elm.querySelector('.member-text__email');

                description.classList.toggle('hidden');
                email.classList.toggle('hidden');
            }
        }
    }
</script>

<style>
    p { margin: 0 !important; padding: 0 !important; }
    .member-item {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .image-overflow-container {
        overflow: hidden;
        height: 128px;
        width: 128px;
        border-radius: 50%;
        box-shadow: -1px -1px 4px #000;
        margin: 20px 25px 5px;
        transition: box-shadow 0.3s ease-in;
    }
    .member-text__name { padding: 5px 0; font-weight: bold;}
    .member-item img {
        width: inherit;
        height: inherit;
        transition: transform 0.3s ease-in;
        cursor: pointer;
    }
    .member-text{
        width: 200px;
        padding: 5px;
        border-radius: 5px;
        font-size: 16px;
        position: relative;
    }
    .member-text {
        margin: 0;
    }
    /*.member-item img:hover { transform: scale(1.1); }*/
    /*.member-item:hover .image-overflow-container { box-shadow: 2px 2px 6px #000; }*/

    .member-text__detail-holder { position: relative; }
    .member-text__email {
        font-size: 14px;
        font-style: italic;
        margin-top: 5px;
    }
    /*.member-text__email { position: absolute; top: 0; left: 0; right: 0; }*/
    /*.hidden { opacity: 0; overflow: hidden; }*/
    /*.member-text__description, .member-text__email { transition: opacity 0.3s ease }*/
</style>